<template>
  <div class="booking-confirmation">
    <div class="booking-notice-container">
      <div class="booking-notice">
        <template v-if="isRecce">
          Your recce request has been received and is under review.
        </template>
        <template v-else>
          Your quote submission has been sent for review.
        </template>
      </div>
    </div>
    <h3 class="font-md mb-6 lh-tight">
      If you have any questions related to this enquiry, you can email <a class="wt-bold" href="mailto:bookings@aperfectspace.com">bookings@aperfectspace.com</a> quoting the booking ID or call Kate on 0419546361 or click on the live chat bot.<br/><br/>
      We will respond as soon as our lister has received the enquiry.<br/><br/>
      The team at A Perfect Space
    </h3>
    <div class="mb-6">
      <p class="lh-std">
        <span class="fg-primary"><b class="wt-bold">{{ data.booking_type_label }} Name:</b> {{ data.listing.space_name }}</span>
        <template v-if="typeof data.listing.address !== 'undefined'">in {{ data.listing.address.label }}</template>
      </p>
      <p class="lh-std">
        <span class="fg-primary"><b class="wt-bold">{{ data.booking_type_label }} ID:</b> {{ data.id }}</span>
      </p>
    </div>
    <a class="button primary interactive mb-4" @click="returnToListing">
      Return to listing
    </a>
    <a v-if="$store.getters['user/account']" class="button primary interactive" @click="goToBookings">
      Take me to my dashboard
    </a>
  </div>
</template>

<script>
import BaseModal from "../Base";

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  methods: {
    returnToListing () {
      this.$emit('cancel')
    },
    goToBookings () {
      this.$store.commit('findspace/navigateToSubpage', { page: 'bookings', subpage: 'home' })
      this.$emit('cancel')
    }
  },
  computed: {
    isRecce () {
      return this.data.type === 'recce'
    }
  }
}
</script>
